<template>
  <div>
        <el-row :gutter="0" class="eltable row flex-col" style="margin-top:0px">
          <el-col :span="24">
            <div class="gridContent bggray2 fb tc">
              问题反馈单-{{ commit.feedbackNumber }}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2 tc">标题</div>
          </el-col>
          <el-col :span="20">
            <div class="gridContent">{{ commit.feedTitle }}</div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2 tc">反馈人</div>
          </el-col>
          <el-col :span="8">
            <div class="gridContent">{{ commit.feedUser }}</div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2 tc">反馈日期</div>
          </el-col>
          <el-col :span="8">
            <div class="gridContent">{{ dateFormat(commit.feedDate) }}</div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2 tc">联系方式</div>
          </el-col>
          <el-col :span="8">
            <div class="gridContent">{{ commit.telephone }}</div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2 tc">是否匿名</div>
          </el-col>
          <el-col :span="8">
            <div class="gridContent">
              {{ commit.isAnonymous == 1 ? "否" : "是" }}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2 tc">受理部门</div>
          </el-col>
          <el-col :span="8">
            <div class="gridContent">{{ commit.receiveDept }}</div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2 tc">办理人</div>
          </el-col>
          <el-col :span="8">
            <div class="gridContent">
              {{ commit.handleUser != null ? commit.handleUser : "" }}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2" style="
                display: flex;
                align-items: center;
                justify-content: center;
                height: 50px;
              ">
              问题说明
            </div>
          </el-col>
          <el-col :span="20">
            <div class="gridContent" style="height: 50px">
              {{ commit.feedContent }}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2 tc" style="
                display: flex;
                align-items: center;
                justify-content: center;
                height: 50px;
              ">
              建议
            </div>
          </el-col>
          <el-col :span="20">
            <div class="gridContent" style="height: 50px">
              {{ commit.advice }}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2 tc" style="
                display: flex;
                align-items: center;
                justify-content: center;
                height: 200px;
              ">
              图片/视频
            </div>
          </el-col>
          <el-col :span="20">
            <div class="gridContent" style="height: 200px">
              <div v-for="item in commit.pics" :key="item.name" class="avatar"
                style="position: relative; margin-left: 1px; object-fit: fill">
                <el-image v-if="
                  item.type == 'jpg' ||
                  item.type == 'png' ||
                  item.type == 'gif' ||
                  item.type == 'bmp' ||
                  item.type == 'jpeg'
                " :key="item.name" height="88px" :preview-src-list="srcList" :src="item.url" width="88px" />
                <video v-if="item.type == 'MOV' || item.type == 'mp4'" :preload="preload" :height="height"
                  :width="width" align="center" :controls="controls" :autoplay="autoplay" style="" type="video/mp4"
                  :src="item.url"></video>
                <!-- <i class="close el-icon-error" @click="removeUpfile(item)"></i> -->
              </div>
            </div>
          </el-col>
        </el-row>
  </div>
</template>
  
<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import "../static/css/my.css";
import axios from "axios";
import { uploadPath, fileAcquisition } from "@/config/net.config.js";
import moment from "moment";

export default {
  name: "feedbackDetailIframe",
  data() {
    return {
      commit: {},
      id: "e015456ccbeb4248a5c8873e566f4b44",//a473f45f069d4b34bebf4f9c07d7d3c8,e015456ccbeb4248a5c8873e566f4b44
      url: "",
      xzztcToken: "",
      uploadPath: uploadPath,
      fileAcquisition: fileAcquisition,
      playStatus: "",
      muteStatus: "",
      isMute: true,
      isPlay: false,
      width: "88", // 设置视频播放器的显示宽度（以像素为单位）
      height: "88", // 设置视频播放器的显示高度（以像素为单位）
      preload: "auto", //  建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      controls: true, // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      autoplay: "",
      srcList: [],
      enlarges: [],
      contentHeight: 0,
      heightDiv: 0,
    };
  },
  computed: {},
  mounted() {
    this.xzztcToken = sessionStorage.getItem("xzztcToken")
    this.id = this.$route.query.runid
    this.getFeedback();
    this.getHeight();
  },
  methods: {
    enlarge(url) {
      this.enlarges = []
      this.enlarges.push(url)
      console.log(this.enlarges);
    },
    getHeight() {
      this.$nextTick(function () {
        this.contentHeight =
          document.getElementsByClassName("row")[0].clientHeight;
        this.heightDiv = this.contentHeight - 60 + "px";
        this.contentHeight = this.contentHeight + "px";
        console.log(this.contentHeight, this.heightDiv); //元素高度
      });
    },
    dateFormat(date) {
      if (date != null && date != "") {
        return moment(date).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    getFeedback() {
      axios.defaults.headers["authorization"] = this.xzztcToken;
      //get，可以设置全局地址提高代码复用率，减少自己写代码，就不用每个都写这么长的地址，嘿嘿
      axios.defaults.baseURL = this.url;
      axios
        .get("/api/xzztc/feedback/obtainFeedbackDetail", {
          params: {
            feedId: this.id,
          },
        })
        .then((res) => {
          // console.log(res.data.data);
          if (
            res.data.msgCode == 0 &&
            res.data.data != {} &&
            res.data.data != null
          ) {
            this.commit = res.data.data;
            if (this.commit.pics != null && this.commit.pics != undefined)
              this.commit.pics = JSON.parse(this.commit.pics);
            if (this.commit.pics != []) {
              this.commit.pics.forEach((item) => {
                if (item.type != "MOV" && item.type != "mp4") {
                  this.srcList.push(item.url);
                }
              });
            }
            this.commit.handleProcess.forEach((item) => {
              item.handleTime = moment(item.handleTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            });
            if (this.commit.accomplishTime != null) {
              this.commit.accomplishTime = moment(
                this.commit.accomplishTime
              ).format("YYYY-MM-DD HH:mm:ss");
            }

            this.active = this.commit.handleProcess.length;
            console.log(this.active);
          }
        });
    },
    goBack() {
      this.$router.push("/userCenter");
    }
  },
  components: {
    // HelloWorld
  },
};
</script>
<style>

.el-tabs__item.is-active {
  color: #2c3e50 !important;
  font-weight: bold;
}

.eltable {
  border-left: 1px solid #ddd;
  margin-top: 20px;
  border-top: 1px solid #ddd;
}

.eltable .gridContent {
  padding: 10px 8px;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  min-height: 21px;
}

.rightTable {
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}


.el-rate__icon {
  font-size: 28px;
}

.bggray2 {
  background-color: #e2f3cf;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
  margin-right: 10px;
}

.avatar {
  width: 88px;
  height: 88px;
  float: left;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-right: 10px;
  line-height: 88px;
  text-align: center;
  /* display: block;  */
}

>>>.el-image__error,
>>>.el-image__inner,
>>>.el-image__placeholder {
  width: 100%;
  height: 88px;
}

.btn1.el-button {
  background-color: #008A2C;
  color: white;
}

.btn1.el-button:hover {
  color: white;
  border-color: #e0fae8;
  background-color: #008a2cc9;
}
</style>